module.exports = __webpack_public_path__ + "assets/images/BSD10.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/BSD10.png
// module id = 1315
// module chunks = 1